const success = document.querySelector('#contrastToggle');
const warning = document.querySelector('#easyreadingToggle');

let toastContainer;

function generateToast({
  message,
  background = '#00214d',
  color = '#fffffe',
  length = '3000ms',
}) {
  toastContainer.insertAdjacentHTML('beforeend', `<p class="toast" 
    style="background-color: ${background};
    color: ${color};
    animation-duration: ${length};
    aria-live='polite'
    role='alert'
    aria-label='${message}'">
    ${message}
  </p>`)
  const toast = toastContainer.lastElementChild;
  toast.addEventListener('animationend', () => toast.remove())
}

(function initToast() {
  document.body.insertAdjacentHTML('afterbegin', `<div class="toast-container"></div>
  <style>
  
.toast-container {
  position: fixed;
  top: 2.5rem;
  right: 1rem;
  display: grid;
  justify-items: end;
  gap: 1.5rem;
  z-index:999;
}

.toast {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1;
  padding: 0.5em 1em;
  background-color: #193e72;
  color:#fff;
  animation: toastIt 3000ms cubic-bezier(0.785, 0.135, 0.15, 0.86) forwards;
}

@keyframes toastIt {
  0%,
  100% {
    transform: translateY(-150%);
    opacity: 0;
  }
  10%,
  90% {
    transform: translateY(0);
    opacity: 1;
  }
}
  </style>
  `);
  toastContainer = document.querySelector('.toast-container');
})()

success.addEventListener('click', (e) => {
  generateToast({
    message: e.currentTarget.dataset.message,
    background: "#193e72",
    color: "#ffffff",
    length: "5000ms",
  })
})


warning.addEventListener("click", (e) => {
  generateToast({
    message: e.currentTarget.dataset.message,
    background: "#193e72",
    color: "#ffffff",
    length: "5000ms",
  });
});